// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.platform-pause-notice {
  position: fixed;
  top: var(--page-header-height, 80px);
  left: 0;
  z-index: 10;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 34px;
  padding: 14px 20px;
  background: #fff176;
  color: #1f1f1f;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.35;
  text-align: center;
}

.platform-pause-notice__icon {
  flex: none;
  font-size: 16px;
  line-height: 1;
}

@media (max-width: 767.98px) {
  .platform-pause-notice {
    padding: 14px 16px;
    font-size: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/layout/PlatformPauseNotice.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,oCAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,UAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE;IACE,kBAAA;IACA,eAAA;EACF;AACF","sourcesContent":[".platform-pause-notice {\n  position: fixed;\n  top: var(--page-header-height, 80px);\n  left: 0;\n  z-index: 10;\n  display: flex;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  min-height: 34px;\n  padding: 14px 20px;\n  background: #fff176;\n  color: #1f1f1f;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.35;\n  text-align: center;\n}\n\n.platform-pause-notice__icon {\n  flex: none;\n  font-size: 16px;\n  line-height: 1;\n}\n\n@media (max-width: 767.98px) {\n  .platform-pause-notice {\n    padding: 14px 16px;\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
